const useIsRtlLanguage = (languageShortCode: string) => {
  const rtlLanguages = ['ar', 'fa', 'he', 'ur', 'yi', 'ku', 'ps', 'arc', 'prs'];

  return rtlLanguages.includes(languageShortCode);
};

export default useIsRtlLanguage;
